import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { FixedLimitLAService } from '../../service/limite-adicional-proposal/fixed-limit-la.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmComponent } from '../../../shared/confirm/confirm.component';

import * as moment from 'moment';
import 'moment/locale/pt-br';
import { IMyDpOptions } from 'mydatepicker';

export interface RequestFixedModel {

	proposalID: string;
	approvalLC: number;
	aprovalFinal: boolean;
	group: number;

	approvalFinanceGroup: [{
		Integrante: string,
		LimiteSugerido: string,
		VigenciaSugerida: any,
		VigenciaFimSugerida: any,
		LC: any,
		Vigencia: any,
		VigenciaFim: any,
		ContaClienteID: string,
		PropostaLCAdicionalId: string,
		Rating: string
	}];

}

@Component({
	selector: 'app-fixed-limit-la',
	templateUrl: './fixed-limit-la.component.html',
	styleUrls: ['./fixed-limit-la.component.scss'],
	providers: [
		FixedLimitLAService
	]
})

export class FixedLimitLAComponent extends DialogComponent<RequestFixedModel, boolean> implements RequestFixedModel {

	proposalID: string;
	approvalLC: number;
	aprovalFinal = false;
	group: number = 0;

	approvalFinanceGroup: [{
		Integrante: string,
		LimiteSugerido: string,
		VigenciaSugerida: any,
		VigenciaFimSugerida: any,
		LC: any,
		Vigencia: any,
		VigenciaFim: any,
		ContaClienteID: string,
		PropostaLCAdicionalId: string,
		Rating: string
	}];
	
	total: number;
	integrantes: any[] = [];

	private today = new Date();

	//Option to datepicker
	private myDatePickerOptions: IMyDpOptions = {
		// other options...
		dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
		monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
		dateFormat: 'dd/mm/yyyy',
		showTodayBtn: false,
		disableSince: { year: this.today.getFullYear() + 1, month: this.today.getMonth() + 1, day: this.today.getDate() + 1 },
		disableUntil: { year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() - 1 },
		//disableDateRanges: [{begin: {year: 2016, month: 11, day: 14}, end: {year: 2016, month: 11, day: 20}}],
		//editableDateField: false,
		height: "30px"
	};

	constructor(dialogService: DialogService, private router: Router, private flashMessagesService: FlashMessagesService, private fixedLimitLAService: FixedLimitLAService) {
		super(dialogService);
	}

	ngOnInit() {
		if (this.approvalFinanceGroup.length > 1) {
			this.approvalFinanceGroup.forEach(element => {
				if (element.VigenciaFimSugerida) {
					var date = moment(element.VigenciaFimSugerida);
					element.VigenciaFim = { date: { year: date.year(), month: date.month() + 1, day: date.date() } };
				}
				element.LC = element.LimiteSugerido;
			});
		} else {
			if (this.approvalFinanceGroup[0].VigenciaFimSugerida) {
				var date = moment(this.approvalFinanceGroup[0].VigenciaFimSugerida);
				this.approvalFinanceGroup[0].VigenciaFim = { date: { year: date.year(), month: date.month() + 1, day: date.date() } };
			}
			this.approvalFinanceGroup[0].LC = this.approvalFinanceGroup[0].LimiteSugerido;
		}
	}

	validateDate(date, i) {
		var max = moment(new Date()).add(1, 'year');
		if (moment(date.jsdate) > max) {
			this.approvalFinanceGroup[i].VigenciaFim = null;
			this.flashMessagesService.show("A vigência final não pode ser maior que um ano.", { cssClass: 'alert-danger', timeout: 6000 });
		}
	}

	getTotal() {
		let total = 0;
		for (var i = 0; i < this.approvalFinanceGroup.length; i++) {
			if (this.approvalFinanceGroup[i].LC) {
				total += this.approvalFinanceGroup[i].LC;
				this.total = total;
			}
		}
		return total;
	}

	garanteVigencia() {
		let vigenciaEmpty = false;

		this.approvalFinanceGroup.forEach(element => {
			if (!element.VigenciaFim ||
				!element.VigenciaFim.date.year ||
				!element.VigenciaFim.date.month ||
				!element.VigenciaFim.date.day) {
				vigenciaEmpty = true;
			}
		});

		if (vigenciaEmpty) {
			this.flashMessagesService.show("Não é possível fixar limite sem uma vigência válida.", { cssClass: 'alert-danger', timeout: 6000 });
		}

		return !vigenciaEmpty;
	}

	fixLimit() {

		if (this.garanteVigencia()) {

			var message = 'Confirma a fixação dos limites preenchidos?';
			let disposable = this.dialogService.addDialog(ConfirmComponent, {
				title: 'Confirmação de Fixação',
				message: message
			},
				{ backdropColor: 'rgba(0, 0, 0, 0.5)' })
				.subscribe((isConfirmed) => {
					//We get dialog result
					if (isConfirmed) {
						this.fixLimitList();
					}
					else {
						//Do nothing here
					}
				});

		}
	}

	fixLimitList() {
		this.approvalFinanceGroup.forEach(element => {
			element.VigenciaFim = element.VigenciaFim.date.year + "-" + element.VigenciaFim.date.month + "-" + element.VigenciaFim.date.day;
		});
		console.log('approvalFinanceGroup', this.approvalFinanceGroup);		
		this.fixedLimitLAService.fixLimitList(this.approvalFinanceGroup).subscribe(result => {
			if (result.Success) {
				this.result = true;
				this.close();
			} else {
				this.result = false;
				this.close();
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/limite-adicional-proposal/component/fixed-limit-la/fixed-limit-la.component.ts